import styled from '@emotion/styled';
import React from 'react';
import { animated, useSpring } from 'react-spring';

interface IProps {
  isOpen: boolean;
}

const Path = styled(animated.path)`
  transform-origin: center center;
  transform: rotate(0deg);
`;

export const ExpandArrow = ({ isOpen }: IProps) => {
  const rotate = useSpring({
    transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
  });

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="13">
      <Path
        style={{ ...rotate } as any}
        fill="#1E3D5A"
        fillRule="evenodd"
        d="M21.112 0l1.01 1.01L12.07 11.061l.05.05-1.01 1.01-.05-.05-.05.05L10 11.112l.05-.051L0 1.01 1.01 0l10.05 10.05L21.112 0z"
      ></Path>
    </svg>
  );
};
